import React, { useState, useMemo } from 'react';
import { Container, Col, Row } from "react-bootstrap";
import { StyledKfTable } from '../../../../Styling/styledTable/StyledTable';
// import UseTableSorter from '../../../components/useTable/UseTable';
import usePaginator from '../../../../components/useTable/UsePaginator';
import UseTableSorter from '../../../../components/useTable/UseTable';
import { TableBorder, TitleSectionTables, KredittvurderingForm, KredittvurderingTd, StyledKvTable } from '../../../../Styling/styledKredittvurdering/styledKvComponents';


const AksjonaererTable = (props) => {

    const localeMessages = props.localeMessages;
    const kvState = props.kredittvurderingState;
    const ratingData = props.fetchedRating;

    // State for grid sorting
    const [currentSeq, setCurrentSeq] = useState('up'); // default
    const [currentField, setCurrentField] = useState('organisasjonsnummer');    // feltnavn
    const [currentType, setCurrentType] = useState('num'); // num
    const [sortClicked, setSortClicked] = useState(0);

    const [masterT1ChangeSortField, t1GetSortFunc, t1IndicaterIcon] = UseTableSorter(
        currentSeq, setCurrentSeq,
        currentField, setCurrentField,
        currentType, setCurrentType
    )

    // Nødvendig pga henting av memoised felt
    const t1ChangeSortField = (fieldName, fieldType) => {
        masterT1ChangeSortField(fieldName, fieldType)

        // Sett trigger for å tvinge memoized function til rerender
        setSortClicked(Date.now())
    }

    const sortedData = useMemo(
        () => {
            if (ratingData.length > 0) {
                return ratingData.sort(t1GetSortFunc().fn)
            }
            else {
                return []
            }
        },
        [ratingData, sortClicked]
    );

    // state for grid paginator
    const [numberPrPage, setNumberPerPage] = useState(5)
    const [activePage, setActivePage] = useState(1);


    const [Paginate, PaginationNav, PaginationDropdown, PaginationIndex, resetPagination] = usePaginator(
        sortedData,
        numberPrPage, setNumberPerPage,
        activePage, setActivePage
    )

    const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
      return (
        <thead>
            <tr>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('name', 'string')}>{localeMessages['GH_name']}{t1IndicaterIcon('name')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('type', 'string')}>{localeMessages['GH_eierskapstype']}{t1IndicaterIcon('type')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('shareClass', 'string')}>{localeMessages['GH_aksjeklasse']}{t1IndicaterIcon('shareClass')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('numberOfOwnedShares', 'string')}>{localeMessages['GH_antallAksjerEierskap']}{t1IndicaterIcon('numberOfOwnedShares')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('totalNumberOfCompanyShares', 'string')}>{localeMessages['GH_totaltAntallAksjerSelskap']}{t1IndicaterIcon('totalNumberOfCompanyShares')}</th>
                <th style={{ backgroundColor: 'white' }} onClick={() => t1ChangeSortField('shareOfOwnership', 'num')}>{localeMessages['GH_andelEierskapBroek']}{t1IndicaterIcon('shareOfOwnership')}</th>
            </tr>
        </thead>
      )
    }

    const printRow = (model) => {
        return (
            <tr key={model.i}>
               <KredittvurderingTd>{model.owner.name}</KredittvurderingTd>
               <KredittvurderingTd>{model.owner.type}</KredittvurderingTd>
               <KredittvurderingTd>{model.shareClass}</KredittvurderingTd>
               <KredittvurderingTd>{model.numberOfOwnedShares}</KredittvurderingTd>
               <KredittvurderingTd>{model.totalNumberOfCompanyShares}</KredittvurderingTd>
               <KredittvurderingTd>{model.shareOfOwnership}</KredittvurderingTd>
           </tr>
        )
    }

    return (
        <>
            <Container fluid="true">
                <TableBorder>
                    <KredittvurderingForm>
                        <Col xs={12} md={12}>
                            <TitleSectionTables>Aksjonærer</TitleSectionTables>
                            <PaginationDropdown />
                            <StyledKvTable>
                                {printHeader(t1IndicaterIcon, t1ChangeSortField)}

                                <tbody>
                                    <Paginate>
                                        {/* paginate forventer en funksjon */}
                                        {row => printRow(row)}
                                    </Paginate>
                                </tbody>
                            </StyledKvTable>
                            <br />
                            <PaginationIndex />
                            <br />
                            <PaginationNav />
                            <br/>
                        </Col>
                    </KredittvurderingForm>
                </TableBorder>            
            </Container>

        </>
    )
}

export default AksjonaererTable



